import React, { useContext } from 'react';
import { Container } from 'reactstrap';
import Header from '../../component/Header';
import API from '../../helper/API';
import PatientDetail from './PatientDetail';
import PaymentForm from './PaymentForm';
import { AppContext } from '../../context/app-context';
import { msgAlert } from '../../helper';
import { paymentInit } from '../../helper/mobile';

const Payment = () => {

  const [state, dispatch] = useContext(AppContext);

  const callRazorpay = (data) => {
    
    if(state?.user && state?.user?.userId && state?.user?.groupId && data?.reason) {
      const request = {
        "userId":state.user.userId,
        "groupId":state.user.groupId,
        "appVersion":state.user.appVersion,
        "osType":state.user.osType,
        "userReports":data.reports,
        "consultationReason":data.reason
      }
  
      API.post('/user/consultation', request).then(response => {
        if(response?.status === 201 && response?.data) {
          const requestData = response.data;
          dispatch({
            type: "LIST_CONSULTATION",
            payload: []
          })
          paymentInit(requestData.orderId);
        }
      }).catch(error => {
          console.log("Error Handler", error);
      });
    }else {
      msgAlert('Error...', 'Field missing', true, true);
      return;
    } 

  }

  return (
    <>
      <Header title="Confirm patient details" isBookingNavDisplay={false} />
      <Container>
        <PatientDetail user={state.user} />
        <PaymentForm callRazorpay={callRazorpay} />
      </Container>
    </>
  );
};

export default Payment;